import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { isEmpty } from 'lodash';

import queryString from 'query-string';

import { connect } from 'react-redux';

import { GridColumn as Column } from '@progress/kendo-react-grid';

import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import BobTable from '../../../components/BobTable';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as EnergyActions from '../../../actions/energyActions';
import * as classes from './ExecutiveSummaryEquipmentsTable.module.css';

const ExecutiveSummaryEnergyHogs = ({
    activeEquipmentSystemType,
    bobLoading,
    companies,
    dashboardIsCurrentTimeStamp,
    extendedColumns,
    fetchNavClients,
    fetchSingleEquipment,
    history,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavCompany,
    setNavClient,
    setNavEquipment,
    setNavSite,
    targetNavCompany,
    siteEnergyEquipmentSummary,
    ...props
}) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        let payload = siteEnergyEquipmentSummary;
        if (payload && payload.length > 0) {
            payload = payload.sort((a, b) => a.totalEnergyUse < b.totalEnergyUse).slice(0, 10);
        }
        setData(payload || []);
    }, [siteEnergyEquipmentSummary]);

    const handleNav = async dataItem => {
        let path = '/v2/dashboard/equipment';

        setNavClient({});
        setNavSite({});
        setNavEquipment({});
        setActiveNavClient({});
        setActiveNavSite({});
        setActiveNavEquipment({});

        const queryValues = queryString.parse(history.location.search);
        queryValues.client = dataItem.clientId;
        queryValues.site = dataItem.siteId;
        queryValues.equipment = dataItem.equipmentId;

        if (targetNavCompany.id !== dataItem.companyId) {
            resetNavOptions('all');
            const company = companies.find(item => item.company.id === dataItem.companyId);
            setNavCompany({
                name: company.company.name,
                id:   company.company.id
            });
            fetchNavClients(dataItem.companyId);
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);

        const options = { extendedData: true };
        await fetchSingleEquipment(queryValues, options);
    };

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);

        return `equipment?client=${dataItem.clientId}&company=${queryValues.company}&equipment=${dataItem.equipmentId}&site=${dataItem.siteId}`;
    };

    const formattedCell = props => {
        return (
            <td>
               
                {props.dataItem && props.dataItem[props.field]?props.dataItem[props.field].toFixed(2):''}
            </td>
        );
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.EquipmentName}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <Link
                                to={renderNavUrl(props.dataItem)}
                                onClick={
                                    (e) => {
                                        if (!e.ctrlKey) {
                                            handleNav(props.dataItem);
                                        }
                                    }
                                }
                            >
                                {props.dataItem[props.field]}
                            </Link>
                        </div>
                    }
                />
            </td>
        );
    };

    const nameFooterCell = props => {
        return (
            <td className={props.className} colSpan={extendedColumns ? 1 : 0} style={props.style}>
                Total
            </td>
        );
    };

    const totalFooterCell = props => {
        const field = props.field || '';
        let total = data.reduce((acc, current) => acc + current[field], 0);
        total = total.toFixed(2);
        let imgPath = null;

        if (props.field === 'lowFaultCount') {
            imgPath = '/assets/images/low.svg';
        } else if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }

        return (
            <td className={props.className} style={props.style}>
                {imgPath ? <img className={classes.Icon} src={imgPath} alt="" /> : null}
                {total}
            </td>
        );
    };

    const defaultColumns = extendedColumns ? [
        {
            key:        0,
            title:      'Equipment',
            field:      'equipmentName',
            cell:       nameCell,
            footerCell: nameFooterCell,
            id:         'equipName',
            width:      !extendedColumns ? 'auto' : 250,
            show:       true
        },
        {
            key:        1,
            title:      'Energy (Kwh)',
            field:      'totalEnergyUse',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'faults',
            width:      100,
            show:       true
        },
        {
            key:        2,
            title:      'Energy use/heating degree day',
            field:      'energyPerHeatingDegreeday',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'high',
            width:      200,
            show:       true
        },
        {
            key:        3,
            title:      'Energy use/cooling degree day',
            field:      'energyPerCoolingDegreeday',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'faults',
            width:      200,
            show:       true
        },
        {
            key:        4,
            title:      'Cost ($)',
            field:      'cost',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'high',
            width:      100,
            show:       true
        },
        {
            key:        5,
            title:      'CO2 (lbs)',
            field:      'totalEnergyUse',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'medium',
            width:      100,
            show:       true
        }
    ] : [
        {
            key:        0,
            title:      'Equipment',
            field:      'equipmentName',
            cell:       nameCell,
            footerCell: nameFooterCell,
            id:         'equipName',
            width:      !extendedColumns ? 'auto' : 250,
            show:       true
        },
        {
            key:        1,
            title:      'Energy (Kwh)',
            field:      'totalEnergyUse',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'faults',
            width:      100,
            show:       true
        },
        {
            key:        2,
            title:      'Cost ($)',
            field:      'cost',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'high',
            width:      100,
            show:       true
        },
        {
            key:        3,
            title:      'CO2 (lbs)',
            field:      'costConversion',
            footerCell: totalFooterCell,
            cell:       formattedCell,
            id:         'medium',
            width:      100,
            show:       true
        }
    ];
    let columns = defaultColumns.filter(c => c.show).map(col => {
        return (
            <Column
                key={col.key}
                field={col.field}
                title={col.title}
                cell={col.cell}
                footerCell={col.footerCell}
                id={col.id}
                width={col.width}
            />
        );
    });



    return (
        <ExecutiveSummaryTile isLoading={bobLoading.includes('FetchSiteEnergyData')}>

            {bobLoading.includes('FetchSiteEnergyData') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <div>
                    {isEmpty(siteEnergyEquipmentSummary) ?
                        <NoSelectedSensorsScreen
                            style={{
                                width: '100%'
                            }}
                            message="Please select a site from the dropdown list above to load the Energy data."
                        />
                        : <div>

                            <BobTable
                                altStyle={true}
                                data={data ? data : []}
                                columns={columns}
                                className={classes.EquipmentGrid}
                                isPageable={false}
                                scroll={'scrollable'}
                            />
                        </div>
                    }
                </div>
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading:                  state.bob.bobLoading,
        dashboardIsCurrentTimeStamp: state.dashboard.dashboardIsCurrentTimeStamp,
        targetNavCompany:            state.bob.targetNavCompany,
        siteEnergyEquipmentSummary:  state.energy.siteEnergyEquipmentSummary
    };
};

const mapDispatchToProps = ({
    ...BobActions,
    ...DashboardActions,
    ...EnergyActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummaryEnergyHogs));
